import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('jobPackagesVolume', jobPackagesVolume);

function jobPackagesVolume($filter, splitService) {
  return function jobPackagesVolumeFilter(packages, enableSuffix) {

    const volumeUnit = $filter('translate')(splitService.getVolumeUnit());
    let hasAnyVolume = false;

    const itemsVolumeSum = _.reduce(packages, function (sum, p) {
      if (!_.isUndefined(p?.volume)) {
        hasAnyVolume = true;
      }
      return sum + _.get(p, 'volume', 0);
    }, 0);

    let decimalNumber: number = Number.isSafeInteger(itemsVolumeSum) ? 0 : 2;


    return enableSuffix ? `${itemsVolumeSum.toFixed(decimalNumber)} ${volumeUnit}` : itemsVolumeSum.toFixed(decimalNumber);
  }
}
